import _ from "lodash";
import { parseBullet } from "../../utils";
import { ExperienceDate } from "./ExperienceDate";
import { featureFlags } from "../../data/";
import "./Experience.scss";


function Experience({
  position,
  company,
  location,
  startDate,
  endDate,
  skills,
  companyLogo,
  companyLink,
  bullets,
}) {
  return (
    <div className="experience">
      <h3 className="experience__title">
        <div className="experience__company-logo">{companyLogo}</div>

        {position}, {"\u00A0"}
        <a target="blank" href={companyLink}>
          {company}
        </a>

        {featureFlags.showExperienceLocation && (
          <span className="experience__location">
            {"\u00A0"}
            <address>{location}</address>
          </span>
        )}

        <ExperienceDate startDate={startDate} endDate={endDate} />
      </h3>

      <ul className="experience__tech-skills">
        {skills.map((skill) => (
          <li key={skill}>{skill}</li>
        ))}
      </ul>

      <div className="experience__list">
        <ul className="sc-a6c9c414-0 ihYfLB">
          {!_.isEmpty(bullets) &&
            bullets.map((bullet) => (
              <li key={bullet}>{parseBullet(bullet)}</li>
            ))}
        </ul>
      </div>
    </div>
  );
}

export { Experience };
